module.exports = __webpack_public_path__ + "static/media/cop.3444209f.png";